import { IdInput } from '../../lib/types/utils'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function unassignJourneyFromRad(input: IdInput<{ journeyId: number }>) {
  const { id, journeyId } = input

  return restApiClient
    .url(constructApiUrl(API.rads.unassignJourney.url, { id, journeyId }))
    .delete()
}
